module.exports = __webpack_public_path__ + "img/mos-prime-mobile.9c0a158.png";